import type { I18nService } from '@core/i18n-legacy';
import {
  ReportDashboardComponentKind,
  ReportDashboardComponentViewMode,
  Blueprint,
  HeaderRow,
  TableData,
  ValueRow,
} from '@core/reports-types';
import { SupportedNumberFormat, valueFormatter } from '@core/utils-legacy';

import { hasConversionData } from './shared';

export const funnelTableBlueprint = (i18n: I18nService): Blueprint<TableData> => ({
  match: {
    kind: ReportDashboardComponentKind.Funnel,
    viewMode: ReportDashboardComponentViewMode.Table,
  },

  factory: ({ dataset: originalDataset, meta, component }) => {
    let dataset = originalDataset;
    if (meta.truncateDataset) {
      const truncateLength =
        typeof meta.truncateDataset === 'number'
          ? meta.truncateDataset
          : meta.truncateDataset(component, dataset);
      dataset = dataset.truncateDataset('first', truncateLength);
    }
    const raw = dataset.getRawData();
    const headerRow = <HeaderRow>raw.slice(0, 1).pop();
    const valueRows = <Array<ValueRow<number>>>raw.slice(1);
    const hasConversion = hasConversionData(dataset.metric.metric);

    return {
      vis: <TableData>(<unknown>{
        dimensions: headerRow,
        values: valueRows.map(([dimension, ...values]) => {
          const lastIndex = values.length - 1;

          return [
            dimension,
            ...values.map((value, index) => ({
              formatted:
                hasConversion && index === lastIndex
                  ? value
                  : valueFormatter(
                      value,
                      {
                        unitType: dataset.metric.unitType,
                        unitPrecision: dataset?.meta?.unitPrecision ?? dataset.metric.unitPrecision,
                      },
                      i18n,
                      {
                        number: { format: SupportedNumberFormat.IntlStandard },
                      },
                    ),
              value,
            })),
          ];
        }),
      }),
      dataset,
    };
  },
});
